
import { Component, Mixins, Prop, Vue, Watch } from 'vue-property-decorator';
import Multiselect from 'vue-multiselect';
@Component({
    components: { Multiselect }
})
export default class MultipleSelect extends Vue {
    value: any = [];
    selected: any = null;
    @Prop() preselectedOptions: any;
    @Prop({default: 'La lista está vacía'}) noOptionText: string;
    @Prop({ default: 'No hay elementos que coincidan con la búsqueda' }) noResultsText: string;
    @Prop() options: any;
    @Prop() customLabel: Function;
    @Prop({default: false}) showActiveDot: boolean;
    @Prop() isDisabled: boolean;
    @Prop() preselectFirst: boolean;
    @Prop() closeOnSelect: boolean;
    @Prop() internalSearch: boolean;
    @Prop() selectedLabel: boolean;
    @Prop() multiple: boolean;
    @Prop() showLabels: boolean;
    @Prop() taggable: boolean;
    @Prop() customValue: string;
    @Prop({ default: 'bottom' }) openDirection: string;
    @Prop() trackBy: string;
    @Prop() label: string;
    @Prop() placeHolder: string;
    @Prop() tagPlaceHolder: string;
    @Prop() selectLabel: string;
    @Prop() deselectLabel: string;
    @Prop() classMultiselectWrapper: string;
    @Prop() labelText: string;
    @Prop() maxHeight: number;
    @Prop() showNoResults: boolean;

    getOptionText(option){
        if(this.customLabel){
            return this.customLabel(option)
        }
        return option[this.label]
    }

    mounted() {
        this.value = this.preselectedOptions;
    }

    @Watch('preselectedOptions')
    updatePreselectValue() {
        this.value = this.preselectedOptions;
    }

    addTag(newTag) {
        this.options.push(newTag);
        this.value.push(newTag);
    }

    clearOptionsSelected() {
        this.value = [];
    }

    updateSelected(newSelected) {
        this.selected = newSelected;
    }

    handleSelected(item) {
        this.$emit('selectOption', item);
    }

    removeItem(item) {
        this.$emit('removeOption', item);
    }

    /** El dropdown se abrió / cerró (p. ej. para dejarlo sobresalir de un modal). */
    handleOpen() {
        this.$emit('open');
    }

    handleClose() {
        this.$emit('close');
    }
}
